module.exports = __webpack_public_path__ + "static/media/storyIcon.82f71c24.png";